import { Action } from '@ngrx/store';
import { PaymentMethod } from '@modules/payment/models/paymentMethod.interface';
import { WebPayPreconditions } from '@modules/payment/models/webPayPreconditions.interfaces';
import { SendPaymentData } from '../models/send-payment-data.interface';
import { FormData } from '@codegen';

export enum PaymentTypes {
  GetPaymentClaims = '[Payment] Get payment claims',
  GetPaymentMethods = '[Payment] Get payment methods',
  SetPaymentMethods = '[Payment] Set payment methods',
  SetPayPrecondition = '[Payment] Set pay precondition',
  SendCurrentPayment = '[Payment] Send current payment',
  SetWebPayFormData = '[Payment] Set WebPay form data',
  SetWebPayRedirectUrl = '[Payment] Set WebPay redirect url',
  GetEripData = '[Payment] Get erip initial fee link',
  SetEripPath = '[Payment] Set erip path',
  SetQrCodeLink = '[Payment] Set Qr code link',
  SetCurrentPayment = '[Payment] Set current payment',
  SendCourierPayment = '[Payment] Send courier payment',
}

export class GetPaymentClaims implements Action {
  public readonly type = PaymentTypes.GetPaymentClaims;
  constructor(public payload: string) {}
}

export class SetPaymentMethods implements Action {
  public readonly type = PaymentTypes.SetPaymentMethods;
  constructor(public payload: Array<PaymentMethod> | null) {}
}

export class GetPaymentMethods implements Action {
  public readonly type = PaymentTypes.GetPaymentMethods;
  constructor(public payload: string) {}
}

export class SetPayPrecondition implements Action {
  public readonly type = PaymentTypes.SetPayPrecondition;
  constructor(public payload: WebPayPreconditions) {}
}

export class SendCurrentPayment implements Action {
  public readonly type = PaymentTypes.SendCurrentPayment;
  constructor(public payload: SendPaymentData) {}
}

export class SetWebPayFormData implements Action {
  public readonly type = PaymentTypes.SetWebPayFormData;
  constructor(public payload: FormData[]) {}
}

export class SetWebPayRedirectUrl implements Action {
  public readonly type = PaymentTypes.SetWebPayRedirectUrl;
  constructor(public payload: string) {}
}

export class GetEripData implements Action {
  public readonly type = PaymentTypes.GetEripData;
  constructor(public payload: string) {}
}

export class SetEripPath implements Action {
  public readonly type = PaymentTypes.SetEripPath;
  constructor(public payload: string) {}
}

export class SetQrCodeLink implements Action {
  public readonly type = PaymentTypes.SetQrCodeLink;
  constructor(public payload: string) {}
}

export class SetCurrentPayment implements Action {
  public readonly type = PaymentTypes.SetCurrentPayment;
  constructor(public payload: number) {}
}

export class SendCourierPayment implements Action {
  public readonly type = PaymentTypes.SendCourierPayment;
  constructor(public payload: SendPaymentData) {}
}

export type PaymentAction =
  | GetPaymentClaims
  | GetPaymentMethods
  | SetPaymentMethods
  | SetPayPrecondition
  | SendCurrentPayment
  | SetWebPayFormData
  | SetWebPayRedirectUrl
  | GetEripData
  | SetEripPath
  | SetCurrentPayment
  | SendCourierPayment
  | SetQrCodeLink;
